<template>
  <el-card class="locations" shadow="never">
      <div slot="header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'Facilities' }">Facilities</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <ElButton v-if="hasAccess" @click="routeToCreateFacility">
          Create Facility
      </ElButton>
      <ElTable
          :data="locations"
          style="width: 100%"
          @row-click="routeToFacility"
          v-loading.fullscreen.lock="loading"
          empty-text="No Data"
          height="500px"
      >
          <ElTableColumn
              property="title"
              label="Name"
              :width="300"
              >
          </ElTableColumn>
          <ElTableColumn
              property="code"
              label="Code"
              :width="200"
              >
          </ElTableColumn>
          <ElTableColumn label="Address">
            <template slot-scope="scope"
            >
              {{ scope.row.address ? scope.row.address : scope.row.addressInfo ? `${scope.row.addressInfo.addressLine1 ? scope.row.addressInfo.addressLine1 + ',' : ''} ${scope.row.addressInfo.addressLine2 ? scope.row.addressInfo.addressLine2 + ',' : ''} ${scope.row.addressInfo.city ? scope.row.addressInfo.city + ',' : ''} ${scope.row.addressInfo.state ? scope.row.addressInfo.state + ',' : ''} ${scope.row.addressInfo.pinCode}` : '-'}}
            </template>
          </ElTableColumn>
          <ElTableColumn
              property="manager.name"
              label="Manager"
              :width="250"
              >
          </ElTableColumn>
      </ElTable>
  </el-card>
</template>

<script>
import axios from 'axios';
import { ADMIN_API_BASE } from '../env';

export default {
  name: 'Customers',
  data() {
    return {
      locations: [],
      loading: true,
    };
  },
  async mounted() {
    await this.getFacilities();
  },
  computed:{
    hasAccess() {
      const roles = this.$keycloak.tokenParsed.realm_access.roles;
      if (roles.includes('level_1')) {
        return true;
      }
      return false;
    },
  },
  methods: {
    routeToCreateFacility() {
      this.$router.push({ name: 'Facility Create' });
    },
    routeToFacility(row) {
      // eslint-disable-next-line no-underscore-dangle
      this.$router.push({ name: 'Facility', params: { facility: row._id } });
    },
    async getFacilities() {
      try {
        const response = await axios.get(`${ADMIN_API_BASE}/facilities/portal`, {
          params: {
            limit: 50,
          },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.loading = false;
        this.locations = response.data;
      } catch (err) {
        this.loading = false;
        this.$message.error({ title: 'Error', message: err.response.data });
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Facilities.vue